import * as $ from "jquery";

// This doesn't do much anymore!
export class CampusDetails {
    campusID: number;

    constructor(cid: number) {
        this.campusID = cid;
    }
}
